import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  ShoppingCart,
  Users,
  Skull,
  UserSquare2,
  Users2,
  MapPin,
  CreditCard,
  Database,
  History,
} from 'lucide-react';

const NAV_ITEMS = [
  { id: 'sales', label: 'Sales', icon: <ShoppingCart />, permission: 'sales', path: '/sales' },
  { id: 'harvest_agents', label: 'Harvest Agents', icon: <Users />, permission: 'harvest_agents', path: '/harvest_agents' },
  { id: 'mortality', label: 'Mortality', icon: <Skull />, permission: 'mortality', path: '/mortality' },
  { id: 'employees', label: 'Employees', icon: <UserSquare2 />, permission: 'employees', path: '/employees' },
  { id: 'divider1', type: 'divider', adminOnly: true },
  { id: 'users', label: 'Users', icon: <Users2 />, adminOnly: true, path: '/users' },
  { id: 'locations', label: 'Locations', icon: <MapPin />, adminOnly: true, path: '/locations' },
  { id: 'payment_details', label: 'Payment Details', icon: <CreditCard />, adminOnly: true, path: '/payment_details' },
  { id: 'database', label: 'Database', icon: <Database />, adminOnly: true, path: '/database' },
  { id: 'sessions', label: 'Sessions', icon: <History />, adminOnly: true, path: '/sessions' },
];

function AppSidebar({ user, hasPermission, isOpen, onNavClick }) {
  return (
    <aside className={`app-sidebar ${isOpen ? '' : 'closed'}`}>
      <nav className="sidebar-nav">
        {NAV_ITEMS.map(item => {
          if (item.type === 'divider') {
            if (item.adminOnly && user.role !== 'admin') return null;
            return <div key={item.id} className="sidebar-divider" />;
          }
          if (item.adminOnly && user.role !== 'admin') return null;
          if (item.permission && !hasPermission(item.permission)) return null;

          return (
            <NavLink
              key={item.id}
              to={item.path}
              className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
              onClick={onNavClick}
            >
              {item.icon}
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}

export default AppSidebar;
